export const DIALOGUE_INPUT = 'DIALOGUE_INPUT' as const;
export const DIALOGUE_OUTPUT = 'DIALOGUE_OUTPUT' as const;
